import { inject, Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { TaskStatus } from '@core/api';
import { enumToOptionSet } from '@shared/utils/enumToOptionSet';

export interface StatusOptionsContext {
  isTask7ExecuteOptionalService: boolean;
  isTask11SubmitInvoiceToScanCenter: boolean;
  hasEditedLocations: boolean;
  hasExistingAddendumOffer: boolean;
}

@Injectable()
export class TaskStatusOptionsService {
  private readonly translateService = inject(TranslateService);

  build(ctx: StatusOptionsContext): any[] {
    const allOptions = enumToOptionSet(
      TaskStatus,
      this.translateService,
      'taskmodule.shared.status'
    ).map(option =>
      option.value === TaskStatus.Storniert
        ? { ...option, label: 'Ablehnen' }
        : option
    );

    let baseOptions = ctx.isTask7ExecuteOptionalService
      ? allOptions.filter(
          o =>
            o.value !== TaskStatus.Storniert &&
            o.value !== TaskStatus.Abgeschlossen
        )
      : allOptions.filter(o => o.value !== TaskStatus.Nachtragsangebot);

    if (ctx.isTask11SubmitInvoiceToScanCenter) {
      baseOptions = baseOptions.filter(o => o.value !== TaskStatus.Storniert);
    }

    const addendumIndex = baseOptions.findIndex(
      o => o.value === TaskStatus.Nachtragsangebot
    );
    if (addendumIndex > -1) {
      const [addendumOption] = baseOptions.splice(addendumIndex, 1);
      baseOptions.splice(1, 0, {
        ...addendumOption,
        disabled: !ctx.hasEditedLocations || ctx.hasExistingAddendumOffer,
      });
    }
    return baseOptions;
  }

  /** Aktualisiert rekursiv alle 'newStatus'-Felder mit aktuellen Optionen */
  refreshFields(
    fields: FormlyFieldConfig[] = [],
    ctx: StatusOptionsContext
  ): void {
    for (const field of fields) {
      if (field?.key === 'newStatus') {
        field.props = { ...(field.props || {}), options: this.build(ctx) };
      }
      if (field?.fieldGroup?.length) {
        this.refreshFields(field.fieldGroup, ctx);
      }
    }
  }
}
